import moment from 'moment';

export const genMomentRangeArray = (start, end, unit = 'day', step = 1) => {
	if (!moment.isMoment(start) || !moment.isMoment(end) || !start.isValid() || !end.isValid()) return [];
	const i = moment(start);
	const ret = [];
	while (i.isSameOrBefore(end)) {
		ret.push(moment(i));
		i.add(step, unit);
	}
	return ret;
};